import {Module} from "vuex";
import {RootState} from "@/store/types";
import {smsStatistic} from "@/store/sms/statistic";
import {smsTemplate} from "@/store/sms/templates";

export const smsModule: Module<any, RootState> = {
  modules: {
    smsStatistic,
    smsTemplate,
  }
}